import React, {
  useReducer,
  useMemo,
  useEffect,
  Reducer,
  ReactNode,
} from "react";

import { NewRequestServices } from "../model/services.model";
import { NewRequestState } from "../model/form.model";

import { NewRequestAction } from "./actions";
import { newRequestReducer } from "./reducer";
import { initialNewRequestState } from "./initial";

import { useUserState } from "@context/UserContext";

import { maskCNPJ } from "@utils/index";

type INewRequestContext = {
  services: NewRequestServices;
  state: NewRequestState;
  dispatch: React.Dispatch<NewRequestAction>;
};

const NewRequestContext = React.createContext<INewRequestContext | null>(null);

const NewRequestProvider = (props: {
  children: ReactNode;
  services: NewRequestServices;
}) => {
  const userState = useUserState();

  const companies = useMemo(() => {
    return (
      userState?.listCNPJ?.map((item) => ({
        key: item.CNPJ,
        value: `${item.companyName} | ${maskCNPJ(item.CNPJ)}`,
      })) ?? []
    );
  }, [userState?.listCNPJ]);

  const [state, dispatch] = useReducer<
    Reducer<NewRequestState, NewRequestAction>
  >(newRequestReducer, initialNewRequestState);

  const value = useMemo(() => ({ services: props.services, state, dispatch }), [
    props.services,
    state,
  ]);

  useEffect(() => {
    dispatch({ type: "purchase/setCompanies", value: companies });
  }, [companies]);

  return (
    <NewRequestContext.Provider value={value}>
      {props.children}
    </NewRequestContext.Provider>
  );
};

export default NewRequestProvider;

export function useNewRequestContext(): INewRequestContext {
  const ctx = React.useContext(NewRequestContext);
  if (!ctx) {
    throw new Error(
      "useNewRequestContext must be used within NewRequestProvider"
    );
  }
  return ctx;
}
